@if ((content && items?.length && items[0].image) || client.isCms) {
<div class="w-12 p-t-12-x p-t-12-l p-b-12-x p-b-12-l"
     [ngClass]="content?.styles?.bg ? 'bg-' + content?.styles?.bg : ''">
    <div class="wrap-x wrap-l">
        <div *ifSize="'XL'">
            <!-- 4th item at the top (if exists) -->
            @if (items?.length === 4 && items[3]) {
            <div class="m-b-6"
                 [grid]="3"
                 [gridColumnGap]="2">
                <!-- 4th item image/video - takes 2/3 width -->
                <div [gridColumn]="2">
                    <div class="ratio-16-9">
                        @if (items[3].video) {
                        <vimeo-player [video-url]="items[3].video"
                                      [background]="!items[3].showVideoControlPanel"
                                      class="bg-col-w rf"
                                      [autoplay-in-viewport]="true"
                                      [loop]="true"
                                      [controls]="items[3].showVideoControlPanel">
                        </vimeo-player>
                        } @else if (items[3].image) {
                        <img [image]="items[3].image"
                             class="rf">
                        }
                    </div>
                </div>

                <!-- 4th item copy in right column - takes 1/3 width -->
                <div [gridColumn]="1"
                     class="flex flex-column flex-justify-center">
                    <div class="p-l-4">
                        <h3 class="h3"
                            [ngClass]="content?.titleColor || 'col-1'">
                            {{items[3].title}}
                        </h3>

                        <p class="m-t-2 p1"
                           [ngClass]="content?.descColor || 'col-1'"
                           [innerHtml]="items[3]?.desc">
                        </p>
                    </div>
                </div>
            </div>
            }

            <!-- First 3 items in standard layout -->
            <div [grid]="3"
                 [gridColumnGap]="2">
                @for (item of items.slice(0, 3); track item; let i = $index) {
                <div class="w-12"
                     [gridColumn]="1">
                    <div class="ratio-1-1">
                        @if (item.video) {
                        <vimeo-player [video-url]="item.video"
                                      [background]="!item.showVideoControlPanel"
                                      class="bg-col-w rf"
                                      [autoplay-in-viewport]="true"
                                      [loop]="true"
                                      [controls]="item.showVideoControlPanel">
                        </vimeo-player>
                        } @else if (item.image) {
                        <img [image]="item.image"
                             class="rf">
                        }
                    </div>

                    <div class="p-l-2 p-t"
                         *ngIf="items?.length === 3 || items?.length === 4">
                        <h3 class="h3"
                            [ngClass]="content?.titleColor || 'col-1'">
                            {{item.title}}
                        </h3>

                        <p class="m-t-2 p1"
                           [ngClass]="content?.descColor || 'col-1'"
                           [innerHtml]="item?.desc">
                        </p>
                    </div>
                </div>
                }

                <!-- Copy for items when not 3 or 4 items -->
                @if (items?.length !== 3 && items?.length !== 4) {
                <div class="w-12 p-b-8 flex flex-column flex-justify-center"
                     [gridColumn]="1">
                    @for (item of items; track item) {
                    <div class="p-l p-t-6">
                        <h3 class="h3"
                            [ngClass]="content?.titleColor || 'col-1'">
                            {{item.title}}
                        </h3>

                        <p class="m-t-2 p1"
                           [ngClass]="content?.descColor || 'col-1'"
                           [innerHtml]="item?.desc">
                        </p>
                    </div>
                    }
                </div>
                }
            </div>
        </div>

        <div *ifSize="'SM'">
            <!-- 4th item first (if exists) -->
            @if (items?.length === 4 && items[3]) {
            <div class="ratio-16-9">
                @if (items[3].video) {
                <vimeo-player [video-url]="items[3].video"
                              [background]="!items[3].showVideoControlPanel"
                              class="bg-col-w rf"
                              [autoplay-in-viewport]="true"
                              [loop]="true"
                              [controls]="items[3].showVideoControlPanel">
                </vimeo-player>
                } @else if (items[3].image) {
                <img [image]="items[3].image"
                     class="rf">
                }
            </div>

            <div class="p-l-2 p-t-2 p-b-2">
                <h3 class="h4"
                    [ngClass]="content?.titleColor || 'col-1'">
                    {{items[3].title}}
                </h3>

                <read-more class="block m-t-1 p1"
                           [ngClass]="content?.descColor || 'col-11'"
                           [text]="items[3].desc"
                           [limit]="'77'"
                           readMore="...read more"
                           readLess="...read less"
                           [mobileReadMoreColor]="content?.descColor || 'col-11'"
                           [showIcon]="false">
                </read-more>
            </div>
            }

            @switch (items?.length) {
            @case (1) {
            <div class="ratio-1-1">
                @if (items[0].video) {
                <vimeo-player [video-url]="items[0].video"
                              [background]="!items[0].showVideoControlPanel"
                              class="bg-col-w rf"
                              [autoplay-in-viewport]="true"
                              [loop]="true"
                              [controls]="items[0].showVideoControlPanel">
                </vimeo-player>
                } @else if (items[0].image) {
                <img [image]="items[0].image"
                     class="rf">
                }
            </div>

            <div class="p-l-2 p-t-2 p-b-2">
                <h3 class="h4"
                    [ngClass]="content?.titleColor || 'col-1'">
                    {{items[0].title}}
                </h3>

                <read-more class="block m-t-1 p1"
                           [ngClass]="content?.descColor || 'col-11'"
                           [text]="items[0].desc"
                           [limit]="'77'"
                           readMore="...read more"
                           readLess="...read less"
                           [mobileReadMoreColor]="content?.descColor || 'col-11'"
                           [showIcon]="false">
                </read-more>
            </div>
            }

            @default {
            <carousel [slidesPerView]="1.25"
                      [spaceBetween]="15">
                @for (item of (items?.length === 4 ? items.slice(0, 3) : items); track item) {
                <ng-template swiperSlide>
                    <div class="ratio-1-1">
                        @if (item.video) {
                        <vimeo-player [video-url]="item.video"
                                      [background]="!item.showVideoControlPanel"
                                      class="bg-col-w rf"
                                      [autoplay-in-viewport]="true"
                                      [loop]="true"
                                      [controls]="item.showVideoControlPanel">
                        </vimeo-player>
                        } @else if (item.image) {
                        <img [image]="item.image"
                             class="rf">
                        }
                    </div>

                    <div class="p-l-2 p-t p-b">
                        <h3 class="h4"
                            [ngClass]="content?.titleColor || 'col-1'">
                            {{item.title}}
                        </h3>

                        <read-more class="block m-t-2 p1"
                                   [ngClass]="content?.descColor || 'col-11'"
                                   [text]="item.desc"
                                   [limit]="'68'"
                                   readMore="...read more"
                                   readLess="...read less"
                                   [mobileReadMoreColor]="content?.descColor || 'col-11'"
                                   [showIcon]="false">
                        </read-more>
                    </div>
                </ng-template>
                }
            </carousel>
            }
            }
        </div>
    </div>
</div>
}
